import { afterAttack, defineGameCard } from '../authoring/index.js';
export const MorozkoFridgeCard = defineGameCard({
    id: 'morozko_fridge',
    gameplay: { type: 'UNIT', cost: 4, baseStats: { attack: 3, health: 6 } },
    presentation: {
        name: 'Холодильник «Морозко»',
        description: 'Когда атакует, заморозьте Холодильник и цель на 1 бой.',
        glyph: {
            colors: ['#10213A', '#EBEEF1', '#A5B0BD', '#E1E6EA', '#C3CCD6'],
            rows: [
                '....111111111111....',
                '...12222222222231...',
                '..1244444444443351..',
                '..1241444444443351..',
                '..1241444444443351..',
                '..1241444444443351..',
                '..1241444444443351..',
                '..1243444444441351..',
                '..1222222222223351..',
                '..1244444444443351..',
                '..1241444444443351..',
                '..1241444444443351..',
                '..1241444444443351..',
                '..1243444444441351..',
                '..1244444444443351..',
                '..1244444444443351..',
                '..1244444444443351..',
                '..1244444444443351..',
                '..1244411111143351..',
                '...1111......1111...',
            ],
        },
    },
    role: 'playable',
    abilities: [
        afterAttack((ctx, event) => {
            const self = ctx.self;
            if (self === undefined
                || event.attackerId !== self.id)
                return;
            const liveSelf = ctx.q.allUnits().find((unit) => unit.id === self.id);
            if (liveSelf !== undefined)
                ctx.ops.freeze(liveSelf.id, 1);
            const target = event.target;
            if (target.kind !== 'unit')
                return;
            const liveTarget = ctx.q.allUnits().find((unit) => unit.id === target.instanceId);
            if (liveTarget !== undefined)
                ctx.ops.freeze(liveTarget.id, 1);
        }),
    ],
    ui: { mechanics: ['freeze'] },
});
//# sourceMappingURL=morozko_fridge.js.map